import { Component, Inject, ElementRef,ViewChild, Optional, OnInit,Injectable } from '@angular/core';
import { MatDialog,MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EstructuraJerarquicaService } from '../../../services/estructura-jerarquica.service';
import { EstructuraJerarquica } from 'app/main/models/estructura-jerarquica.model';
import { TipoEvaluacion } from 'app/main/models/tipo-evaluacion.model'
import { NodoEstructuraJerarquica } from 'app/main/models/nodo-estructura-jerarquica.model';
import { MatTable } from '@angular/material/table';
import {SelectionModel} from '@angular/cdk/collections';
import {FlatTreeControl} from '@angular/cdk/tree';
import {MatTreeFlatDataSource, MatTreeFlattener} from '@angular/material/tree';
import {BehaviorSubject} from 'rxjs';
import { UtilsService } from '../../../services/utils.service';
import { TokenStorageService } from 'app/main/auth/token-storage.service';
import { SelectDuenoDialogBoxComponent} from './user-select-dialog-box.component'


import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import { first } from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';


interface ExampleFlatNode {
  expandable: boolean;
  name: string;
  level: number;
}

@Component({
  selector: 'app-dialog-box',
  templateUrl: './node-selector-dialog-box.component.html',
  styleUrls: ['./node-selector-dialog-box.component.scss']
})
export class NodeSelectorDialogBoxComponent {

  action: string;
  LOCAL_DATA: any;
  role = [];

  usuario = null;
  tipoUsuario = null;
  nombreDueno = "Dueño";
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  estructura = null;
  tieneEstructuraBase:boolean = false;
  ownerSelector:boolean = false;
  estructuras: EstructuraJerarquica[] = [];
  tipoEvaluacion: TipoEvaluacion = null;

  private _transformer = (node: NodoEstructuraJerarquica, level: number) => {
    return {
      expandable: !!node.hijos && node.hijos.length > 0,
      name: node.nombre,
      level: level,
      data: node,
      enabled: node.enabled
    };
  }

  treeControl = new FlatTreeControl<ExampleFlatNode>(
      node => node.level, node => node.expandable);

  treeFlattener = new MatTreeFlattener(
      this._transformer, node => node.level, node => node.expandable, node => node.hijos);

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  @ViewChild(MatTable, {static: true}) table: MatTable<any>;

  constructor(
    public dialog: MatDialog,
    public translate: TranslateService,
    private storage: TokenStorageService,
    public dialogRef: MatDialogRef<NodeSelectorDialogBoxComponent>,
    public service:EstructuraJerarquicaService,
    public utils:UtilsService,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
      this.dialogRef.disableClose = true;
      this.usuario = data.usuario;
      this.tipoUsuario = data.tipoUsuario;
      this.nombreDueno = (data.tipoUsuario && data.tipoUsuario==4) ? "Dueño" : "Evaluador";
      this.ownerSelector = data.ownerSelector || false;
      this.tipoEvaluacion = data.tipoEvaluacion;
      if(data.estructura!=null){
        this.tieneEstructuraBase = true;
        this.estructura = data.estructura;
        this.loadNodos();
      }

  }

  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;

  doAction(nodo): void{
    //Si no tiene selector de owner cierra, sino abre el selector de owner
    if(!this.ownerSelector){
      console.log('im here');
      this.dialogRef.close({event: this.action, data: {nodo:nodo.data,estructura:this.estructura,usuario:this.usuario}});
    }else{
      this.selectDueno(nodo);

    }
  }

  closeDialog(): void{
    this.dialogRef.close({event: 'Cancel'});
  }


  ngOnInit(): void {

    this.role = this.storage.getRole();

    //Si es el especialista en riesgos debe de poder preiniciar una evaluacion donde quiera. Mail GR 6/09/2021.
    if(this.usuario==null || this.role.includes(5)){
      this.service.getAll(0,1000).pipe().subscribe(req => {
        var estructurasD = req.body.map( dimension => {
          return dimension;
        });

        if(this.tipoEvaluacion!=null){
          var estructurasF = [];
          estructurasD.forEach(estructura => {
            estructura.tipoEvaluacion.forEach(tipo => {
              if(tipo.id == this.tipoEvaluacion.id &&
                  estructurasF.indexOf(estructura) ==-1)
                  estructurasF.push(estructura);
            });
          });

          this.estructuras = [...estructurasF];
        }else{
          this.estructuras = [...estructurasD];
        }


      });
    }else{
      this.service.getAllByUser(this.usuario).pipe().subscribe(req => {
        var estructurasD = req.body.map( dimension => {
          return dimension;
        });

        if(this.tipoEvaluacion!=null){
          var estructurasF = [];
          estructurasD.forEach(estructura => {
            estructura.tipoEvaluacion.forEach(tipo => {
              if(tipo.id == this.tipoEvaluacion.id &&
                  estructurasF.indexOf(estructura) ==-1)
                  estructurasF.push(estructura);
            });
          });

          this.estructuras = [...estructurasF];
        }else{
          this.estructuras = [...estructurasD];
        }
      });
    }
  }


  loadNodos():void{

    this.service.get(this.estructura.id).pipe().subscribe(req => {
      this.estructura = new EstructuraJerarquica(req.body);
      //this.dataSourceList = data.dataSource;
      this.orderStructure(this.estructura.nodos);
      if(this.usuario!=null){
        this.containsUser(this.estructura.nodos,false);
      }else{
        this.containsUser(this.estructura.nodos,true);
      }
      this.dataSource.data = this.estructura.nodos;

    });

  }

  orderStructure(nodos):void{

    for(var z=0; nodos.length>z;z++){
      nodos.sort(this.utils.sortAlphaNum);
      this.orderStructure(nodos[z].hijos);
    }
  }

  containsUser(nodos:NodoEstructuraJerarquica[],parentVal:boolean){

    this.role = this.storage.getRole();
    nodos.forEach(nodo => {
      //Si es el especialista en riesgos debe de poder preiniciar una evaluacion donde quiera. Mail GR 6/09/2021.
      nodo.enabled = parentVal || this.role.includes(5);
      if(!parentVal)
        nodo.usuarios.forEach(element => {
          if(element.correoElectronico==this.usuario)
            nodo.enabled = true;
        });

      this.containsUser(nodo.hijos,nodo.enabled);
    });
  }

  selectDueno(nodo): void {
    var obj = {usuarios:nodo.data.usuarios,tipo:this.tipoUsuario,nombre:this.nombreDueno};
    const dialogRef = this.dialog.open(SelectDuenoDialogBoxComponent, {
      width: '100%',
      data: obj,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {

      this.usuario = result.data;
      if(this.usuario!=null)
        this.dialogRef.close({event: this.action, data: {nodo:nodo.data,estructura:this.estructura,usuario:this.usuario}});

    });
  }



}
